import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const WorkspaceSettingsOAuthLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./oauth-settings'),
});
